import { FC, useEffect, useState } from "react";

interface FancyLoaderProps {
  className?: string;
  words?: string[];
}

export const FancyLoader: FC<FancyLoaderProps> = ({
  className = "",
  words = ["Enhancing", "Polishing", "Beautifying"],
}) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const fadeInTimer = setTimeout(() => {
      setIsVisible(true);
    }, 750);

    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 1000);

    return () => {
      clearTimeout(fadeInTimer);
      clearInterval(interval);
    };
  }, [words.length]);

  const currentWord = words[currentWordIndex];
  const letters = currentWord.split("");
  return (
    <>
      <style>{`
        .loader-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 180px;
          height: 180px;
          font-family: "Inter", sans-serif;
          font-size: 1.2em;
          font-weight: 300;
          color: white;
          border-radius: 50%;
          background-color: transparent;
          user-select: none;
          opacity: 0;
          transition: opacity 0.5s ease-in-out;
        }

        .loader-wrapper.visible {
          opacity: 1;
        }

        .loader {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          aspect-ratio: 1 / 1;
          border-radius: 50%;
          background-color: transparent;
          animation: loader-rotate 4s linear infinite;
          z-index: 0;
        }

        @keyframes loader-rotate {
          0% {
            transform: rotate(90deg);
            box-shadow:
              0 10px 20px 0 #fff inset,
              0 20px 30px 0 #02704D  inset,
              0 60px 60px 0 #83EDCB inset;
          }
          50% {
            transform: rotate(270deg);
            box-shadow:
              0 10px 20px 0 #fff inset,
              0 20px 10px 0 #408BE3 inset,
              0 40px 60px 0 #408BE3 inset;
          }
          100% {
            transform: rotate(450deg);
            box-shadow:
              0 10px 20px 0 #fff inset,
              0 20px 30px 0 #02704D inset,
              0 60px 60px 0 #83EDCB inset;
          }
        }

        .loader-letter {
          display: inline-block;
          opacity: 0.4;
          transform: translateY(0);
          animation: loader-letter-anim 1s infinite;
          z-index: 1;
          border-radius: 50ch;
          border: none;
          color: #374151;
        }

        @keyframes loader-letter-anim {
          0%,
          100% {
            opacity: 0.8;
            transform: translateY(0);
          }
          20% {
            opacity: 1;
            transform: scale(1.15);
          }
          40% {
            opacity: 0.8;
            transform: translateY(0);
          }
        }
      `}</style>
      <div
        className={`loader-wrapper ${isVisible ? "visible" : ""} ${className}`}
      >
        {letters.map((letter, index) => (
          <span
            key={`${currentWordIndex}-${index}`}
            className="loader-letter"
            style={{
              animationDelay: `${index * 0.1}s`,
            }}
          >
            {letter}
          </span>
        ))}

        <div className="loader"></div>
      </div>
    </>
  );
};
